const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function formatDisplayDate(value, options, fallback = '—') {
  if (!value) return fallback;
  const text = String(value);
  const dateOnly = DATE_ONLY_PATTERN.test(text);
  const parsed = new Date(dateOnly ? `${text}T00:00:00Z` : value);
  if (Number.isNaN(parsed.getTime())) return text;
  return parsed.toLocaleDateString('en-US', {
    ...options,
    ...(dateOnly ? { timeZone: 'UTC' } : {}),
  });
}
